/** Minimum pointer travel (px) before a gesture counts as a swipe. */
export const SWIPE_THRESHOLD_PX = 48;
